import React from "react";
import Image from "next/image";
import { useSelector } from "react-redux";
import { PiFileText } from "react-icons/pi";
import noImage from "@/public/images/placeholders/landscape-placeholder.svg";

/**
 * WizardHeader — branded card header with company logo, name, and form label.
 */
export default function WizardHeader() {
  const { organization } = useSelector(state => state.borrowerLoanOriginationStore);

  return (
    <div className="flex shrink-0 flex-col gap-4 border-b border-gray-200 bg-white px-6 py-6 sm:flex-row sm:items-center sm:justify-between sm:px-8 sm:py-8 dark:border-slate-700 dark:bg-slate-900">
      {/* Left — Logo + Company Name */}
      <div className="flex items-center gap-4">
        <Image
          alt={organization?.organizationName || "Company"}
          src={organization?.logoUrl || noImage}
          className="size-16 rounded-full border-2 border-gray-100 bg-white object-cover shadow-sm dark:border-slate-700"
          width={64}
          height={64}
        />
        <div>
          <h1 className="text-xl font-bold capitalize text-gray-900 dark:text-white">
            {organization?.organizationName}
          </h1>
          <p className="text-sm text-gray-500 dark:text-slate-400">
            Welcome — please complete the form below
          </p>
        </div>
      </div>

      {/* Right — Form Label Badge */}
      <div className="flex items-center gap-2 self-start rounded-full border border-indigo-200 bg-indigo-50 px-4 py-2 sm:self-center dark:border-indigo-800 dark:bg-indigo-950">
        <PiFileText className="size-5 text-indigo-600 dark:text-indigo-400" />
        <span className="text-sm font-semibold text-indigo-700 dark:text-indigo-300">
          Loan Inquiry Form
        </span>
      </div>
    </div>
  );
}



